<template>
  <div class="fixed-agent-card">
    <!-- <div class="share-info" v-if="isSharePage">{{ getShareTitle }}</div> -->
    <div v-for="agent of info" :key="agent.id" class="agent-info">
      <div class="agent-name">
        <div
          v-if="agent.avatar && agent.avatar.url"
          class="agent-avatar"
          :style="`background-image:url('${$processImage(agent.avatar.url, { resize: 'mid' })}')`"
        ></div>
        <div class="agent-detai">
          <p class="font-bold font-color">{{ agent.nickname || agent.username }}</p>
          <p v-if="agent.title">{{ agent.title }}</p>
          <p v-if="agent.dre">Dre: {{ agent.dre }}</p>
        </div>
      </div>
      <div class="agent-actions">
        <a v-if="agent.email" class="agent-button" :href="'mailto:' + agent.email">
          <font-icon id="email"></font-icon>
          Email me: {{ agent.email }}
        </a>
        <div v-if="agent.phone" class="agent-button">
          <font-icon id="phone"></font-icon>
          Call me: {{ agent.phone }}
        </div>
        <div
          v-if="!isSharePage"
          class="agent-button agent-button-border"
          @click="showDrawer"
        >{{ $t('bookView') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Array,
      default () {
        return []
      }
    },
    lang: {
      type: String,
      default: 'en-US',
    },
  },
  data () {
    return {}
  },
  computed: {
    isSharePage () {
      return !!this.$route.params.agent
    },
    type () {
      return this.$route.name === 'sharerent' ? 'rental' : 'sell'
    },
    // getShareTitle() {
    // if (this.lang === 'en-US') {
    //   return (
    //     this.info.nickname +
    //     ' shares a ' +
    //     (this.type === 'rental' ? 'rental' : 'sell' ? 'Rental' : 'Selling') +
    //     ' property with you'
    //   )
    // } else {
    //   return (
    //     this.info.nickname +
    //     ' 分享给你一个' +
    //     (this.type === 'rental' ? 'rental' : 'sell' ? '租房信息' : '在售房产信息')
    //   )
    // }
    // },
  },
  mounted () {
    console.log(this.info)
  },
  methods: {
    showDrawer () {
      this.$emit('showDrawer', this.info)
    },
  },
}
</script>
<style lang="scss" scoped>
.fixed-agent-card {
  width: 100%;
  margin: 20px 0;
  box-sizing: border-box;
  padding: 14px 20px;
  border-radius: 0 0 8px 8px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 4;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  // flex-wrap: wrap;
}

.share-info {
  width: 100%;
  padding: 20px 0;
}

.agent-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f1f1f1;
  }
}
.agent-name {
  display: flex;
  align-items: center;
}

.agent-avatar {
  border-radius: 50%;
  height: 66px;
  width: 66px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  margin-right: 12px;
}

.agent-button,
a.agent-button {
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  background: #99d20d;
  cursor: pointer;
  color: #fff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  text-decoration: none;
  border: 1px solid #99d20d;
}

.agent-button-border {
  color: #99d20d;
  background-color: #fff;
}

.agent-actions {
  display: flex;
}

.agent-name {
  p {
    margin: 0 0 6px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

@media (max-width: 767px) {
  .fixed-agent-card {
    position: static;
    margin: 14px 0;
    padding: 14px;
    border-radius: 8px;
  }

  .agent-info {
    display: block;
  }

  .agent-name {
    align-items: flex-start;
  }

  .agent-detai {
    min-width: 0;
    word-break: break-word;
  }

  .agent-avatar {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
  }

  .agent-actions {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
  }

  .agent-button,
  a.agent-button {
    width: 100%;
    height: auto;
    min-height: 38px;
    line-height: 1.35;
    margin: 0 0 8px;
    padding: 9px 12px;
    box-sizing: border-box;
    justify-content: center;
    text-align: center;
    word-break: break-word;
  }
}
</style>
